/* @flow */

import React from 'react';
import ResourceSelector from 'shared/components/ResourceSelector';

type Props = {
  open: boolean,
  onSelected: resource => void,
  onClose: () => void,
};

const AddFileModal = ({ open, onSelected, onClose }: Props) => (
  <ResourceSelector
    resourceType="all"
    open={open}
    onResourceSelected={onSelected}
    onClose={onClose}
  />
);

export default AddFileModal;



// WEBPACK FOOTER //
// ./src/modules/my-space/components/AddFileModal.js